(function () {
  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-gp-open-drawer]");
    var closeBtn = e.target.closest("[data-gp-close-drawer]");
    if (openBtn) {
      document
        .querySelectorAll("[data-gp-drawer],[data-gp-overlay]")
        .forEach(function (el) {
          el.classList.add("is-open");
        });
    }
    if (closeBtn || e.target.matches("[data-gp-overlay]")) {
      document
        .querySelectorAll("[data-gp-drawer],[data-gp-overlay]")
        .forEach(function (el) {
          el.classList.remove("is-open");
        });
    }
    var buyNow = e.target.closest("[data-gp-buy-now]");
    if (buyNow) {
      var buyNowForm = buyNow.closest("form");
      if (buyNowForm) {
        var returnTo = document.createElement("input");
        returnTo.type = "hidden";
        returnTo.name = "return_to";
        returnTo.value = "/checkout";
        buyNowForm.appendChild(returnTo);
        buyNowForm.submit();
      }
    }
    var thumb = e.target.closest("[data-gp-thumb]");
    if (thumb) {
      var image = thumb.querySelector("img");
      var gallery = thumb.closest("[data-gp-gallery]");
      var main = gallery && gallery.querySelector("[data-gp-main-image]");
      if (image && main) {
        main.src = image.dataset.large || image.src;
        main.alt = image.alt || "";
      }
    }
    var mainImage = e.target.closest("[data-gp-main-image]");
    if (mainImage) {
      openLightbox(mainImage);
    }
  });

  var lightbox = null;
  var lightboxState = { images: [], index: 0 };

  function buildLightbox() {
    if (lightbox) return lightbox;
    lightbox = document.createElement("div");
    lightbox.className = "gp-lightbox";
    lightbox.setAttribute("role", "dialog");
    lightbox.setAttribute("aria-modal", "true");
    lightbox.setAttribute("aria-label", "Image viewer");
    lightbox.innerHTML =
      '<button class="gp-lightbox__close" type="button" data-gp-lightbox-close aria-label="Close">&times;</button>' +
      '<button class="gp-lightbox__nav gp-lightbox__nav--prev" type="button" data-gp-lightbox-prev aria-label="Previous image">&#10094;</button>' +
      '<img class="gp-lightbox__image" alt="">' +
      '<button class="gp-lightbox__nav gp-lightbox__nav--next" type="button" data-gp-lightbox-next aria-label="Next image">&#10095;</button>';
    document.body.appendChild(lightbox);

    lightbox.addEventListener("click", function (e) {
      if (e.target.closest("[data-gp-lightbox-prev]")) {
        showLightboxImage(lightboxState.index - 1);
      } else if (e.target.closest("[data-gp-lightbox-next]")) {
        showLightboxImage(lightboxState.index + 1);
      } else if (
        e.target === lightbox ||
        e.target.closest("[data-gp-lightbox-close]")
      ) {
        closeLightbox();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (!lightbox.classList.contains("is-open")) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") showLightboxImage(lightboxState.index - 1);
      if (e.key === "ArrowRight") showLightboxImage(lightboxState.index + 1);
    });

    return lightbox;
  }

  function openLightbox(mainImage) {
    var gallery = mainImage.closest("[data-gp-gallery]");
    var images = [];
    if (gallery) {
      gallery.querySelectorAll("[data-gp-thumb] img").forEach(function (img) {
        var large = img.dataset.large
          ? new URL(img.dataset.large, window.location.href).href
          : img.src;
        images.push({ src: large, alt: img.alt || "" });
      });
    }
    var index = images.findIndex(function (image) {
      return image.src === mainImage.src;
    });
    if (index === -1) {
      images.unshift({ src: mainImage.src, alt: mainImage.alt || "" });
      index = 0;
    }
    lightboxState.images = images;
    buildLightbox();
    lightbox.classList.toggle("gp-lightbox--single", images.length < 2);
    showLightboxImage(index);
    lightbox.classList.add("is-open");
    document.body.classList.add("gp-lightbox-open");
  }

  function showLightboxImage(index) {
    var count = lightboxState.images.length;
    if (!count) return;
    lightboxState.index = (index + count) % count;
    var image = lightboxState.images[lightboxState.index];
    var imageEl = lightbox.querySelector(".gp-lightbox__image");
    imageEl.src = image.src;
    imageEl.alt = image.alt;
  }

  function closeLightbox() {
    lightbox.classList.remove("is-open");
    document.body.classList.remove("gp-lightbox-open");
  }
})();
